"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighlightWords = void 0;
const react_1 = require("react");
class HighlightWords extends react_1.PureComponent {
    render() {
        const { text } = this.props;
        return text;
    }
}
exports.HighlightWords = HighlightWords;
